import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constant, RoleName } from 'src/app/@shared/constants/Constant';
import { IDropdownDataOptions, ITimeZoneModel } from 'src/app/model/common.model';
import { CustomerList, DriverList, FinancialStatusList, VendorList } from 'src/app/service/customer.model';
import { ILoggedInMemberDetailViewModel, MemberPreferenceSettingsModel } from 'src/app/service/memeber.model';
import { IServiceRequestStatusList, ServiceType } from 'src/app/service/service-request';
import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';
import { IGetServiceLocationViewModel } from '../../../../service/vehicle.model';

declare var $: any;
@Component({
  selector: 'app-member-preference-model',
  templateUrl: './member-preference-model.component.html',
  styleUrls: ['./member-preference-model.component.css'],
})
export class MemberPreferenceModelComponent implements OnInit {
  public isTimeZoneEmpty: boolean = false;
  @Input('memberPreferenceSettings') memberPreferenceSettings: MemberPreferenceSettingsModel;

  //Take inputs for DropDown Values
  @Input('serviceTypes') serviceTypes: ServiceType[];
  @Input('statusList') statusList: IServiceRequestStatusList[] = [];
  @Input('customerList') customerList: CustomerList[];
  @Input('regionList') regionList: IDropdownDataOptions[];
  @Input('financialStatusList') financialStatusList: FinancialStatusList[];
  @Input('serviceOriginLocations') serviceOriginLocations: IGetServiceLocationViewModel[];
  @Input('vendorList') vendorList: VendorList[];
  @Input('transportTypeList') transportTypeList: string[];
  @Input('driverList') driverList: DriverList[];
  @Input('coordinatorData') coordinatorData: BaseDropdownInterface[];
  @Input('timeZoneList') timeZoneList: ITimeZoneModel[];
  @Input('dateFilters') dateFilters: string[];
  @Input('toDateFilters') toDateFilters: string[];
  @Input('loader') loader: boolean;

  //dropDownInitialization
  @Input('dropdownSettings') dropdownSettings: any;
  @Input('statusDropdownSettings') statusDropdownSettings: any;
  @Input('customerListSetting') customerListSetting: any;
  @Input('regionDropdownSettings') regionDropdownSettings: any;
  @Input('financialStatusSetting') financialStatusSetting: any;
  @Input('originSetting') originSetting: any;
  @Input('vendorListSetting') vendorListSetting: any;
  @Input('transportTypeListSetting') transportTypeListSetting: any;
  @Input('driverListSetting') driverListSetting: any;
  @Input('coordinatorFilterSetting') coordinatorFilterSetting: any;
  @Input('timezoneConfig') timezoneConfig: any;
  @Output('saveMemberPreferenceSettings') memberPreferenceSettingsEvent = new EventEmitter();
  @Output('closeMemberPreferenceSettingPopup') closeSettingPopup = new EventEmitter();

  public user: ILoggedInMemberDetailViewModel;
  public roleName = RoleName;
  public memberPreferenceSettingsDetails: MemberPreferenceSettingsModel;
  constructor() {}

  ngOnInit() {
    this.memberPreferenceSettingsDetails = JSON.parse(localStorage.getItem('MemberPreferenceSettings'));
    this.initializePopupData();
    this.user = JSON.parse(localStorage.getItem('user'));
  }

  initializePopupData() {
    this.serviceTypes = this.serviceTypes ? this.serviceTypes : [];
    this.statusList = this.statusList ? this.statusList : [];
    this.customerList = this.customerList ? this.customerList : [];
    this.regionList = this.regionList ? this.regionList : [];
    this.regionList.splice(3, 1); //Remove LifeSource option from this region list for filters. (Refer this link for the ticket : https://bladeuam.atlassian.net/browse/TAC-169)
    this.financialStatusList = this.financialStatusList ? this.financialStatusList : [];
    this.serviceOriginLocations = this.serviceOriginLocations || [];
    this.vendorList = this.vendorList?.length ? this.vendorList : [];
    this.transportTypeList = this.transportTypeList || [];
    this.driverList = this.driverList ? this.driverList : [];
    this.coordinatorData = this.coordinatorData ? this.coordinatorData : [];
    this.timeZoneList = this.timeZoneList ? this.timeZoneList : [];
    this.dateFilters = this.dateFilters ? this.dateFilters : [];
    this.toDateFilters = this.toDateFilters ? this.toDateFilters : [];
    if (this.memberPreferenceSettingsDetails && this.memberPreferenceSettingsDetails.selectedTimeZone == null) {
      this.memberPreferenceSettings.selectedTimeZone =
        this.timeZoneList.find((timezone) => timezone.shortName == Constant.selectedTimeZoneShortValue) ?? null;
    }
  }

  saveMemberPreferenceSettings(): void {
    this.memberPreferenceSettingsEvent.emit(this.memberPreferenceSettings);
    $('#userPreferenceSetting').modal('hide');
  }

  closePopup() {
    this.closeSettingPopup.emit();
  }
}
